var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('EsyH2',[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('PlaceList',{attrs:{"items":_vm.items,"exceeded":_vm.exceeded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }